import { 
    CREATE_USER_PENDING, CREATE_USER_FULFILLED, CREATE_USER_REJECTED,
    RETRIEVE_USER_FROM_TOKEN_PENDING, RETRIEVE_USER_FROM_TOKEN_FULFILLED, RETRIEVE_USER_FROM_TOKEN_REJECTED,
    LOGIN_USER_PENDING, LOGIN_USER_FULFILLED, LOGIN_USER_REJECTED,
    GENERATE_TOKEN_PASSWORD_PENDING, GENERATE_TOKEN_PASSWORD_FULFILLED, GENERATE_TOKEN_PASSWORD_REJECTED,
    VERIF_TOKEN_PASSWORD_PENDING, VERIF_TOKEN_PASSWORD_FULFILLED, VERIF_TOKEN_PASSWORD_REJECTED,
    CHANGE_PASSWORD_PENDING, CHANGE_PASSWORD_FULFILLED, CHANGE_PASSWORD_REJECTED
} from './UserConstants'


const INITIAL_STATE = {
    pending: false, fulfilled: false, error: null, provider:null, profile:null, role:null, regions:null, verif:false
}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {

        // CREATE USER
        case CREATE_USER_PENDING:
            return {...state, pending: true, fulfilled: false}
        case CREATE_USER_FULFILLED:
            return {...state, pending: false, fulfilled: false}
        case CREATE_USER_REJECTED:
            return {...state, pending: false, error: action.payload.response}


        case RETRIEVE_USER_FROM_TOKEN_PENDING:
            return {...state, pending: true, fulfilled: false}
        case RETRIEVE_USER_FROM_TOKEN_FULFILLED:
            return {...state, pending: false, fulfilled: true, provider:action.payload.data.provider, role:action.payload.data.role, regions:action.payload.data.regions}
        case RETRIEVE_USER_FROM_TOKEN_REJECTED:
            return {...state, pending: false, error: action.payload.response}


        case LOGIN_USER_PENDING:
            return {...state, pending: true, fulfilled: false}
        case LOGIN_USER_FULFILLED:
            return {...state, pending: false, fulfilled: true, provider:action.payload.data.provider, role:action.payload.data.role}
        case LOGIN_USER_REJECTED:
            return {...state, pending: false, error: action.payload.response}


        case GENERATE_TOKEN_PASSWORD_PENDING:
            return {...state, pending: true, fulfilled: false}
        case GENERATE_TOKEN_PASSWORD_FULFILLED:
            return {...state, pending: false, fulfilled: false}
        case GENERATE_TOKEN_PASSWORD_REJECTED:
            return {...state, pending: false, error: action.payload.response}


        case VERIF_TOKEN_PASSWORD_PENDING:
            return {...state, pending: true, verif: false}
        case VERIF_TOKEN_PASSWORD_FULFILLED:
            return {...state, pending: false, verif: true}
        case VERIF_TOKEN_PASSWORD_REJECTED:
            return {...state, pending: false, error: action.payload.response}


        // DEFAULT
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/user/UserReducer.js